<button
    #originRef
    (click)="showPopover()"
    [class.bg-hover]="dropdownOpen"
    class="button notification-button"
    mat-icon-button
    type="button"
>
    <mat-icon color="primary">notifications_active</mat-icon>
    @if ((unreadCount$ | async) && (unreadCount$ | async)! > 0) {
        <span
            class="notification-badge"
            [attr.data-count]="(unreadCount$ | async)! > 99 ? '99+' : (unreadCount$ | async)"
        >
        </span>
    }
</button>
